export default {
  isMobile() {
    return window.matchMedia('(max-width: 639px)').matches;
  },
  isTablet() {
    return window.matchMedia('(max-width: 767px)').matches;
  },
  isTabletLandscape() {
    return window.matchMedia('(max-width: 1023px)').matches;
  },
  isDesktop() {
    return window.matchMedia('(min-width: 1024px)').matches;
  },
  isBigDesktop() {
    return window.matchMedia('(min-width: 1280px)').matches;
  },
  isAllDesktop() {
    return this.isDesktop() || this.isBigDesktop();
  },
  isAllMobile() {
    return this.isMobile() || this.isTablet() || this.isTabletLandscape();
  }
};
